import { api } from '../../DefaultService';
import {
  ILprDeviceConfigUpdateParams,
  ILprDeviceCreateProps,
  ILprDeviceFilterProps,
  ILprDeviceProps,
  ILprDeviceSimpleProps,
  ILprDeviceUpdateParams,
} from './types';
import { IPaginationParams } from '../../types';

const ENDPOINT = 'v1/devices/cameras/lpr';

export const createLprDeviceAsync = async (
  data: ILprDeviceCreateProps,
): Promise<ILprDeviceProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getLprDeviceByIdAsync = async (
  id: number,
): Promise<ILprDeviceProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllLprDeviceByLicenseAsync = async (
  pagination: IPaginationParams,
  filter: ILprDeviceFilterProps,
): Promise<ILprDeviceSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllLprDeviceCountByLicenseAsync = async (
  filter: ILprDeviceFilterProps,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateLprDeviceAsync = async ({
  id,
  data,
}: ILprDeviceUpdateParams): Promise<ILprDeviceProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteLprDeviceAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const updateConfigLprDeviceAsync = async ({
  id,
  data,
}: ILprDeviceConfigUpdateParams): Promise<void> => {
  await api.put(`${ENDPOINT}/${id}/config`, data).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
